import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=522f3200&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522f3200')) {
      api.createRecord('522f3200', component.options)
    } else {
      api.reload('522f3200', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=522f3200&", function () {
      api.rerender('522f3200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20n1FVUAtIkjU/JS/comp/ErrorMessage.vue"
export default component.exports